import styled from "styled-components";
import { colors } from "../resources/ThemeColors";
import { breakpoints } from "../Media";

export const Button = styled.button`
  height: 2.6em;
  width: 100%;
  background-color: ${colors.main};
  color: ${colors.light};
  border: none;
  border-radius: 12px;
  margin-top: 1em;
  font-size: 1em;
  font-weight: 700;
  cursor: pointer;

  :hover {
    background-color: ${colors.light};
    color: ${colors.main};
    border: 1px solid ${colors.main};
  }
  :focus {
    outline: none;
  }
`;

export const InputBox = styled.input`
  width: ${(props) => (props.half ? "43%" : "95%")};
  height: 3em;
  border: 1px solid black;
  border-radius: 12px;
  padding-left: 1.5em;
  margin-top: ${(props) => (props.top ? "1em" : "0em")};
  margin-left: ${(props) => (props.left ? ".6em" : "0em")}

  :hover {
    border: 1px solid ${colors.main};
  }
  :focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-left: ${(props) => (props.left ? ".6em" : "0em")}

  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${
  breakpoints.mobileMax
}) {
    margin-left: ${(props) => (props.left ? ".6em" : "0em")}

  }
`;
